import { useTranslation } from '../i18n';
import Navbar from "./Navbar";
import JaninaAndCharles from "./JaninaAndCharles";
import RibbonDivider from "./RibbonDivider";
import WeAreSayingYes from "./WeAreSayingYes";
import InvitationText from "./InvitationText";
import Invitation from "./Invitation";
import Footer from "./Footer";
import Ablauf from "./Ablauf";
import Anreise from "./Anreise";
import RSVP from "./RSVP";
import Contact from "./Contact";

function TwoDayPage() {
  const { t } = useTranslation();
  
  const navItems = [
    { label: t('navigation.ablauf'), anchor: "ablauf" },
    { label: t('navigation.anreise'), anchor: "anreise" },
    { label: "RSVP", anchor: "rsvp" },
    { label: t('navigation.kontakte'), anchor: "kontakte" },
  ];

  return (
    <>
      <Navbar items={navItems} />
      <main>
        <section id="janina-charles">
          <JaninaAndCharles />
        </section>
        <RibbonDivider />
        <section id="we-are-saying-yes">
          <WeAreSayingYes />
        </section>
        <section id="invitation-text">
          <InvitationText />
        </section>
        <section id="invitation">
          <Invitation />
        </section>
        <section id="ablauf">
          <Ablauf isOneDay={false} />
        </section>
        <section id="anreise">
          <Anreise isOneDay={false} />
        </section>
        <section id="rsvp">
          <RSVP />
        </section>
        <section id="kontakte">
          <Contact />
        </section>
      </main>
      <Footer />
    </>
  );
}

export default TwoDayPage;